import {Component, Input, OnDestroy, ViewEncapsulation} from '@angular/core';

@Component({
    selector     : 'striped-bars-card',
    templateUrl  : './striped-bars-card.component.html',
    styleUrls    : ['./striped-bars-card.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class StripedBarsCardComponent implements OnDestroy {

    /**
     * Constructor
     */
    constructor(
    ) {
    }

    ngOnDestroy(): void {
    }
}
